export default function Dilemmas({ dilemmas, answers, current, setCurrent, onUpdate, onProcess }) {
  const dilemma = dilemmas[current];
  const answer = answers[current];
  const canNext = answer?.choice && (answer?.example?.length || 0) >= 20;
  const allAnswered = answers.every((a) => a.choice && (a.example?.length || 0) >= 20);
  const isLast = current === dilemmas.length - 1;

  return (
    <div className="max-w-2xl mx-auto px-6 py-16">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-white mb-1">Culture Profile</h1>
        <p className="text-gray-400 text-sm">Define your culture through dilemmas — takes about 4 minutes.</p>
      </div>

      <div className="flex items-center gap-1.5 mb-2">
        {dilemmas.map((_, i) => (
          <div key={i} className={`h-2 flex-1 rounded-full transition-colors ${i <= current ? "bg-emerald-400" : "bg-gray-700/60"}`} />
        ))}
      </div>
      <p className="text-sm text-gray-500 mb-8">
        {current + 1} of {dilemmas.length} — {dilemma.axis_label}
      </p>

      <p className="text-lg md:text-xl font-semibold text-gray-100 mb-8 leading-relaxed">{dilemma.situation}</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        {["A", "B"].map((choice) => {
          const label = choice === "A" ? dilemma.choice_a : dilemma.choice_b;
          const isSelected = answer?.choice === choice;
          return (
            <button
              key={choice}
              type="button"
              onClick={() => onUpdate("choice", choice)}
              className={`p-5 rounded-xl border transition-all text-left ${isSelected ? "border-emerald-400 bg-emerald-400/5" : "border-gray-700/60 bg-[#131b2e] hover:border-gray-600"}`}>
              <span className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold mb-3 ${isSelected ? "bg-emerald-400 text-black" : "bg-gray-700 text-gray-400"}`}>
                {choice}
              </span>
              <p className={`text-sm leading-relaxed ${isSelected ? "text-gray-200" : "text-gray-400"}`}>{label}</p>
            </button>
          );
        })}
      </div>

      <div className="mb-8">
        <label className="block text-sm font-semibold text-gray-200 mb-2">Give a real example from your team</label>
        <textarea
          value={answer?.example || ""}
          onChange={(e) => onUpdate("example", e.target.value)}
          placeholder="Describe a specific situation where this happened..."
          rows={4}
          className="w-full bg-[#131b2e] border border-gray-700/60 rounded-xl px-4 py-3 text-sm text-gray-200 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 transition-all resize-none"
        />
        <p className={`text-xs mt-1.5 ${(answer?.example?.length || 0) >= 20 ? "text-gray-500" : "text-emerald-400/70"}`}>
          {answer?.example?.length || 0}/20 min characters
        </p>
      </div>

      <div className="flex items-center justify-between">
        <button
          type="button"
          onClick={() => current > 0 && setCurrent(current - 1)}
          disabled={current === 0}
          className="text-sm text-gray-500 hover:text-gray-300 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
          ← Previous
        </button>
        {isLast ? (
          <button type="button" onClick={onProcess} disabled={!allAnswered} className="bg-emerald-500 hover:bg-emerald-400 disabled:opacity-50 disabled:cursor-not-allowed text-black font-semibold px-6 py-3 rounded-lg transition-all">
            See my results →
          </button>
        ) : (
          <button type="button" onClick={() => setCurrent(current + 1)} disabled={!canNext} className="bg-emerald-500 hover:bg-emerald-400 disabled:opacity-50 disabled:cursor-not-allowed text-black font-semibold px-6 py-3 rounded-lg transition-all">
            Next dilemma →
          </button>
        )}
      </div>
    </div>
  );
}
